import { type ActionItem } from 'shared/ui'
import { IS_APP_LIGHT } from 'shared/config'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { TrialLimitModalStore } from 'entities/Subscription/ui/TrialLimitModal'
import { TwilioNumberSelectionModalStore } from 'entities/Subscription/ui/TwilioNumberSelectionModal'
import { AssignInboxStore, type IAssignInboxProps } from './ui'

export const assignInbox = (
  numbers: IAssignInboxProps['numbers'],
  onCloseAssignInboxModalModal: IAssignInboxProps['onCloseAssignInboxModalModal'],
  entities: IEntitiesStore
): ActionItem => {
  return {
    icon: 'inboxes2',
    text: 'Assign number',
    onAction: () => {
      const hasTwilioIntegrationNumbers = numbers.some(
        (number) => number.number_vendor.key === 'twilio-integration'
      )

      const shouldOpenTwilioNumberSelectionModal =
        entities.organizationStore.isTwilioNumberVendor &&
        entities.usersStore.user?.isRequireNumber &&
        !entities.subscriptionStore.isAgencyWithoutSubscription &&
        !hasTwilioIntegrationNumbers

      if (shouldOpenTwilioNumberSelectionModal && !IS_APP_LIGHT) {
        new TwilioNumberSelectionModalStore(entities).open()
        return
      }

      if (
        entities.subscriptionStore.isTrial &&
        !entities.usersStore.user?.isRequireNumber &&
        !hasTwilioIntegrationNumbers
      ) {
        new TrialLimitModalStore(entities).open('numbers')
        return
      }
      new AssignInboxStore(numbers, onCloseAssignInboxModalModal, entities)
    },
  }
}
